<template>
  <div class="relative">
    <div class="group block w-full">
      <ProjectAssetManagerTileAsset v-if="asset" :asset="asset" />
      <div
        v-else
        class="h-full bg-gray-500 group-hover:opacity-75 flex items-center justify-center"
      >
        <svg
          class="w-8 h-8 text-gray-300"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0
            012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2
            0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      </div>
    </div>
    <ProjectAssetTileApprovalStatus
      v-if="hasApprovalRequests"
      :total="projectAsset.approvalRequestsCount"
      :pending="projectAsset.pendingApprovalRequestsCount"
      :approved="projectAsset.approvedApprovalRequestsCount"
      :rejected="projectAsset.rejectedApprovalRequestsCount"
      class="absolute top-0 left-0 mt-4 ml-4"
    />
  </div>
</template>

<script>
import ProjectAssetManagerTileAsset from './ProjectAssetManagerTileAsset.vue';
import ProjectAssetTileApprovalStatus from './ProjectAssetTileApprovalStatus.vue';

export default {
  components: {
    ProjectAssetManagerTileAsset,
    ProjectAssetTileApprovalStatus,
  },
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasApprovalRequests() {
      if (!this.projectAsset.approvalRequestsCount) {
        return false;
      }

      return this.projectAsset.approvalRequestsCount > 0;
    },
    asset() {
      if (!this.projectAsset?.asset) {
        return null;
      }

      if (typeof this.projectAsset.asset === 'object') {
        return this.projectAsset.asset;
      }

      return this.$store.state.entities.assets.byId[this.projectAsset.asset] || null;
    },
  },
  methods: {
    addProjectAsset() {
      this.$emit('add', this.projectAsset);
    },
  },
};
</script>
